import { render } from "./BoqSectionRowReadOnly.vue?vue&type=template&id=3186b260"
import script from "./BoqSectionRowReadOnly.vue?vue&type=script&lang=js"
export * from "./BoqSectionRowReadOnly.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__